import { View } from "react-native";
import React from "react";
import BaseCard, { BaseCardListItem } from "components/BaseCard";
import {
  TicketCartDetails,
  TicketCartItemDetails,
  TicketDetails,
} from "features/types";
import i18n from "plugins/localization";
import { RenderCardTitle } from "./HoldDetails";
import { formatCurrency } from "utils/appUtils";

interface Props {
  ticket: TicketDetails;
  charge?: TicketCartDetails;
  index: number;
}
const PremiumHoldDetails: React.FC<Props> = (props) => {
  const {
    ticket: { seat, id },
    charge,
    index,
  } = props;

  const ticketCharge = (id: number) =>
    charge?.items.find((item) => item.ticketId === id);

  const getTotalPrice = (charge: TicketCartItemDetails | undefined) => {
    return formatCurrency(charge?.totalPrice, { priceType: charge?.priceType });
  };

  return (
    <View style={{ marginBottom: 10 }}>
      <BaseCard
        title={
          <RenderCardTitle
            index={index + 1}
            charge={charge}
            ticketPrice={getTotalPrice(ticketCharge(id))}
            isGA={seat.ga}
          />
        }
      >
        <BaseCardListItem
          dividerStyle={{ marginVertical: 8 }}
          title={
            seat.ga
              ? i18n.t("common.generalAdmission")
              : `${i18n.t("common.section")}: ${seat.sectionDisplay} ` +
                `${i18n.t("common.row")}: ${seat.rowDisplay} ` +
                `${i18n.t("common.seat", { count: 1 })}: ${seat.seatDisplay}`
          }
          showArrow={false}
        ></BaseCardListItem>
      </BaseCard>
    </View>
  );
};

export default PremiumHoldDetails;
